module.exports = __webpack_public_path__ + "img/associationPACA.f23d4b82.png";